module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "app-content"
  }, [_c('img', {
    attrs: {
      "src": require("../../common/images/totodi.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.appName))]), _vm._v(" "), (_vm.notMatch) ? _c('div', {
    staticClass: "pop"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("请选择版本")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toDownload(1)
      }
    }
  }, [_vm._v("安卓版")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toDownload(2)
      }
    }
  }, [_vm._v("苹果版")])], 1) : _vm._e()]), _vm._v(" "), (_vm.isWeiXin) ? _c('div', {
    staticClass: "poper"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../../common/images/download-tips.png")
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c626a226"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Download/index.vue
// module id = 1087
// module chunks = 1